import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import Cookies from "js-cookie";

const ProtectedRoute = ({ requiredPermission, requireAdmin }) => {
    const token = Cookies.get("authToken");
    const userRole = Cookies.get("userRole");
    const permissionsStr = Cookies.get("userPermissions");

    // 1. Check Authentication
    if (!token) {
        return <Navigate to="/login" replace />;
    }

    // 2. Check Admin Requirement
    if (requireAdmin) {
        if (userRole !== 'ADMIN') {
            return <Navigate to="/" replace />;
        }
        return <Outlet />;
    }

    // 3. Check Specific Permission
    if (requiredPermission) {
        // Admin always has access
        if (userRole === 'ADMIN') return <Outlet />;

        let permissions = [];
        try {
            permissions = permissionsStr ? JSON.parse(permissionsStr) : [];
        } catch (e) { permissions = []; }

        // Check if user has specific permission or wildcard
        if (!permissions.includes(requiredPermission) && !permissions.includes('*')) {
            return <Navigate to="/" replace />;
        }
    }

    // Default: Access granted (or just requiring login)
    return <Outlet />;
};

export default ProtectedRoute;
